import styled from 'styled-components';

export const Center = styled('center')`
  height: inherit;
  display: flex;
  align-content: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
